/**
 *
 * LoadingScreen
 *
 */

import * as PropTypes from "prop-types";
import styled from "styled-components";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";

function LoadingScreen({ showAnimation, style, className }) {
  return (
    <Wrapper style={style} className={className}>
      {showAnimation && <LoadingAnimation />}
    </Wrapper>
  );
}

LoadingScreen.propTypes = {
  showAnimation: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
};

LoadingScreen.defaultProps = {
  showAnimation: true,
  style: {},
  className: "",
};

export default LoadingScreen;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 865px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
